import { combineReducers } from 'redux'
import accessTokens from './accessTokens/reducer'
import activity from './activity/reducer'
import aliases from './aliases/reducer'
import arcLive from './arcLive/reducer'
import atlasLinks from './atlasLinks/reducer'
import atlasModulePanel from './atlasModulePanel/reducer'
import atlasPreview from './atlasPreview/reducer'
import atlasai from './atlasai/reducer'
import auditLog from './auditLog/reducer'
import bank from './bank/reducer'
import bankAccount from './bankAccount/reducer'
import bankTransactions from './bankTransactions/reducer'
import bbc from './bbc/reducer'
import bbcLog from './bbcLog/reducer'
import bdo from './bdo/reducer'
import box from './box/reducer'
import calendar from './calendar/reducer'
import campaigns from './campaigns/reducer'
import capTable from './capTable/reducer'
import cellNotes from './cellNotes/reducer'
import channels from './channels/reducer'
import clientBanners from './clientBanners/reducer'
import clientEmailGroups from './clientEmailGroups/reducer'
import clientInfo from './clientInfo/reducer'
import clientIntake from './clientIntake/reducer'
import collection from './collections/reducer'
import connection from './connection/reducer'
import crm from './crm/reducer'
import customFields from './customFields/reducer'
import dashboard from './dashboard/reducer'
import dueDiligence from './dueDiligence/reducer'
import entityInfo from './entityInfo/reducer'
import errorTriage from './errorTriage/reducer'
import externalApiKey from './externalApiKey/reducer'
import fboBankAccounts from './fboBankAccounts/reducer'
import feedback from './feedback/reducer'
import file from './file/reducer'
import flag from './flag/reducer'
import frequency from './frequency/reducer'
import generalAnalysis from './generalAnalysis/reducer'
import generalLedger from './generalLedger/reducer'
import lcr from './lcr/reducer'
import legal from './legal/reducer'
import legalEntities from './legalEntities/reducer'
import loanBalance from './loanBalance/reducer'
import marketIntelligence from './marketIntelligence/reducer'
import messages from './messages/reducer'
import myTasks from './myTasks/reducer'
import newsfeed from './newsfeed/reducer'
import notes from './notes/reducer'
import notification from './notification/reducer'
import ongoingReporting from './ongoingReporting/reducer'
import options from './options/reducer'
import outgoingWire from './outgoingWire/reducer'
import participant from './participant/reducer'
import passThrough from './passThrough/reducer'
import photo from './photo/reducer'
import plaid from './plaid/reducer'
import presence from './presence/reducer'
import { SIGN_OUT_ACTIONS } from './profile/actions'
import profile from './profile/reducer'
import prospect from './prospect/reducer'
import qbo from './qbo/reducer'
import reportingDocument from './reportingDocument/reducer'
import reports from './reports/reducer'
import requiredReport from './requiredReport/reducer'
import salesforce from './salesforce/reducer'
import savedFilters from './savedFilters/reducer'
import search from './search/reducer'
import taskProjects from './taskProjects/reducer'
import taskRules from './taskRules/reducer'
import teams from './teams/reducer'
import treasury from './treasury/reducer'
import twilio from './twilio/reducer'
import twoFactor from './twoFactor/reducer'
import ui from './ui/reducer'
import user from './user/reducer'

// Let TypeScript infer the root state type from combineReducers

const staticReducers = {
  box,
  collection,
  clientBanners,
  fboBankAccounts,
  clientEmailGroups,
  clientInfo,
  profile,
  salesforce,
  user,
  bank,
  bankAccount,
  requiredReport,
  reportingDocument,
  frequency,
  loanBalance,
  passThrough,
  outgoingWire,
  activity,
  bbc,
  auditLog,
  file,
  ongoingReporting,
  ui,
  aliases,
  bankTransactions,
  capTable,
  lcr,
  prospect,
  dueDiligence,
  generalLedger,
  search,
  bdo,
  entityInfo,
  campaigns,
  crm,
  externalApiKey,
  accessTokens,
  notes,
  clientIntake,
  notification,
  presence,
  connection,
  calendar,
  dashboard,
  arcLive,
  marketIntelligence,
  newsfeed,
  participant,
  bbcLog,
  flag,

  options,
  photo,
  treasury,
  atlasai,
  legal,
  legalEntities,
  twoFactor,
  cellNotes,
  channels,
  messages,
  generalAnalysis,
  plaid,
  qbo,
  atlasLinks,
  atlasPreview,
  atlasModulePanel,
  myTasks,
  taskProjects,
  customFields,
  savedFilters,
  reports,
  taskRules,
  teams,
  feedback,
  errorTriage,
  twilio,
}

const appReducer = combineReducers({
  ...staticReducers,
})

export type IRootState = ReturnType<typeof appReducer>

const reducer = (state: IRootState, action: { type: string }): IRootState => {
  if (SIGN_OUT_ACTIONS.includes(action.type)) {
    state = undefined
  }
  return appReducer(state, action)
}

export default reducer
